import {
  loadingFailAction,
  loadingStartAction,
  loadingSuccessAction,
} from "@wisr/common";
import Axios, { AxiosResponse } from "axios";
import { Epic } from "redux-observable";
import { concat, from, Observable, of } from "rxjs";
import { catchError, concatMap, map } from "rxjs/operators";

import { DASH_API } from "../../shared/url.constants";
import { TermsResponse } from "./terms";
import {
  TermsGetAction,
  TermsGetActionType,
  termsGetSuccessAction,
} from "./terms.actions";

export const GET_TERMS_LOADING = "GET_TERMS_LOADING";
export const getTermsEpic: Epic = (actions) =>
  actions.ofType<TermsGetAction>(TermsGetActionType).pipe(
    concatMap(() =>
      concat(
        of(loadingStartAction(GET_TERMS_LOADING)),
        getTerms().pipe(
          concatMap((termsResponse) => [
            termsGetSuccessAction(termsResponse),
            loadingSuccessAction(GET_TERMS_LOADING),
          ])
        )
      )
    ),
    catchError(() =>
      of(loadingFailAction(GET_TERMS_LOADING, "Unexpected Error"))
    )
  );

function getTerms(): Observable<TermsResponse> {
  return from(
    Axios.get<TermsResponse>(`${DASH_API}/api/v1/rateestimate/terms-consent`)
  ).pipe(map((res: AxiosResponse) => res.data));
}
